import * as React from "react";
import cn from "classnames";
import { Text } from "../Text/Text";

import Styles from "./TabViewChooserItem.module.scss";
import { Clickable } from "../Clickable/Clickable";

export interface TabViewChooserItemProps {
  "data-testid"?: string;
  label: string;
  onClick: () => void;
  active: boolean;
  variant: "chooser" | "selector";
}
function getVariantStyles(variant: "chooser" | "selector"): {
  label: string;
  activeItem: string;
  item: string;
  size: "small" | "base";
  activeTextColor: "off-black" | "cool-grey-dark";
} {
  switch (variant) {
    case "chooser":
      return {
        label: Styles.tabViewChooserLabel,
        activeItem: Styles.activeTabViewChooserItem,
        item: Styles.tabViewChooserItem,
        size: "small",
        activeTextColor: "off-black",
      };
    case "selector":
      return {
        label: "",
        activeItem: Styles.activeSelectorItem,
        item: Styles.selectorItem,
        size: "base",
        activeTextColor: "cool-grey-dark",
      };
  }
}
export const TabViewChooserItem = (props: TabViewChooserItemProps) => {
  const variantStyles = getVariantStyles(props.variant);
  const isActiveItem = props.active ? variantStyles.activeItem : "";
  const textColor = props.active ? "gc-blue" : variantStyles.activeTextColor;
  return (
    <Clickable onClick={() => props.onClick()} data-testid={props["data-testid"]}>
      <div className={cn(variantStyles.item, isActiveItem)} role="tab">
        <Text className={variantStyles.label} size={variantStyles.size} color={textColor} weight={"semibold"}>
          {props.label}
        </Text>
      </div>
    </Clickable>
  );
};
